// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.less
// module id = 869
// module chunks = 0